// React import
import React, { Fragment, useEffect, useState, useCallback } from 'react';
//Material component import
import {Divider  } from "@mui/material";
import { CircularProgress } from "@mui/material";
// custom component import
import dstyles from "./DailyProductionInsight.module.css";
import {ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import styles from "Samarth Module/components/barAndLineComboChart/barAndLineComboChart.module.css";

const PlanChangeResonTrend = ({data, loader})=> {
    const [graphData, setGraphData] = useState([]);
    useEffect(() => {
        setGraphData(data); // for display graph
    }, [data]);
    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span>&nbsp; : &nbsp;
                            {item.value}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };
    
	return(
		<Fragment>
            <div className={dstyles.adoptionDiv}>
                <div className={dstyles.planText}><span>Plan change reason trend</span></div>
                <Divider className={dstyles.hr}/>
                {/* Graph */}
                {loader ? 
                    <div className={dstyles.loaderContainer}><CircularProgress /></div> :
                    <ComposedChart data={graphData}
                        width={600}
                        height={420}
                        margin={{
                            top: 20,
                            right: 0,
                            bottom: 5,
                            left: 20,
                        }} 
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                        <XAxis dataKey="date" tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                            {/* <Label value="Past 4 Weeks" offset={10} position="bottom" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500' }} /> */}
                        </XAxis>
                        <YAxis domain={[0, 'auto']}  axisLine={false} padding={{ left: 0, right: 0 }}
                            tick={{ 
                                fontSize: 10,           // <-- Decrease this number for smaller font
                                fill: '#2B2B2B', 
                                fontWeight: 400 
                            }}
                            label={{
                                value: 'Count',
                                angle: -90,
                                position: 'left',
                                offset: 10,
                                style: {
                                    fill: '#2B2B2B',
                                    fontSize: '10px',
                                    fontWeight: '500',
                                    textAnchor: 'middle',
                                },
                            }}
                        />
                        <Tooltip
                            content={<CustomTooltip />}
                            wrapperStyle={{
                                fontSize: '12px',
                                padding: '6px',
                            }}
                        />
                        <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />
                        
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="Manpower shortfall"
                            name="Manpower shortfall"
                            fill="#005EEF"
                            barSize={12}
                        />
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="Increase in demand"
                            name="Increase in demand"
                            fill="#00b0ff"
                            barSize={12}
                        />
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="Low Indend/Warehouse congestion"
                            name="Low Indend/Warehouse congestion"
                            fill="#00B190"
                            barSize={12}
                        />
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="No RPM"
                            name="No RPM"
                            fill="#1de9b6"
                            barSize={12}
                        />
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="Unplanned breakdown"
                            name="Unplanned breakdown"
                            fill="#00e676"
                            barSize={12}
                        />
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="Planned shutdown"
                            name="Planned shutdown"
                            fill="#64b5f6"
                            barSize={12}
                        />
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="Others"
                            name="Others"
                            fill="#33eaff"
                            barSize={12}
                        />
                    </ComposedChart>
                }
            </div>
		</Fragment>
	);
}

export default PlanChangeResonTrend;